var map = {
	"./discord-logo.webp": 2309,
	"./facebook-logo.webp": 803,
	"./instagram-logo.webp": 2433,
	"./kick-logo.webp": 3589,
	"./kwai-logo.webp": 9467,
	"./linktree-logo.webp": 7803,
	"./telegram-logo.webp": 1546,
	"./tiktok-logo.webp": 7801,
	"./trovo-logo.webp": 7585,
	"./twitch-logo.webp": 3822,
	"./twitter-logo.webp": 9916,
	"./vk-logo.webp": 5714,
	"./whatsapp-logo.webp": 1149,
	"./x-logo.webp": 9989,
	"./youtube-logo.webp": 9634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2774;